var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15.0051C8 15.5551 8.45 16.0051 9 16.0051H21C21.55 16.0051 22 16.4551 22 17.0051C22 17.5551 21.55 18.0051 21 18.0051H18V20.0051H18.8C19.24 20.0051 19.47 20.5451 19.15 20.8551L17.36 22.6451C17.16 22.8451 16.85 22.8451 16.65 22.6451L14.86 20.8551C14.54 20.5451 14.76 20.0051 15.21 20.0051H16V18.0051H8C6.9 18.0051 6 17.1051 6 16.0051V8.00508H3C2.45 8.00508 2 7.55508 2 7.00508C2 6.45508 2.45 6.00508 3 6.00508H6V4.00508H5.21C4.76 4.00508 4.54 3.46508 4.85 3.15508L6.64 1.35508C6.84 1.15508 7.15 1.15508 7.35 1.35508L9.14 3.15508C9.46 3.46508 9.24 4.00508 8.79 4.00508H8V15.0051ZM18 14.0051H16V9.00508C16 8.45508 15.55 8.00508 15 8.00508H10V6.00508H16C17.1 6.00508 18 6.90508 18 8.00508V14.0051Z",
    fill: "#677380"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransition);
export default __webpack_public_path__ + "static/media/transition.562ebd858974aff3d5f893235902f390.svg";
export { ForwardRef as ReactComponent };